import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { unmappedPlantsDataEndpoint } from '../../../common/endpoints';

export const unmappedPlantsData = createApi(unmappedPlantsDataEndpoint, 'GET');

const UnmappedPlants = createSlice({
  name: 'UnmappedPlants',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(unmappedPlantsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(unmappedPlantsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(unmappedPlantsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default UnmappedPlants.reducer;